import { render } from "./ContactFormView.vue?vue&type=template&id=5ab50970&ts=true"
import script from "./ContactFormView.vue?vue&type=script&lang=ts"
export * from "./ContactFormView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__